<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="login-part d-flex align-center justify-center">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="login-part d-flex align-center justify-center flex-column"
            >
              <div class="login-wrapper dark" >
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-container>
                    <v-row class="flex-column text-right">
                      <v-col>
                        <v-text-field
                          v-model="email"
                          label="Email"
                          :rules="usernameRules"
                          outlined
                          hide-details="auto"
                          class="mb-0"
                        ></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-space-between">
                        <v-btn
                          class="text-capitalize flex-grow-1 mr-3"
                          large
                          :disabled="email.length === 0 && !validateEmail"
                          color="primary"
                          @click="forgotPassAction()"
                        >
                          Kirim</v-btn
                        >
                        <v-btn
                          class="text-capitalize flex-grow-1"
                          large
                          text
                          color="primary"
                          to="/"
                        >
                          Batal</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-dialog
          v-model="showDialogSuccess"
          persistent
          max-width="450"
          max-height="350"
          width="100%"
        >
          <v-card class="pa-3">
            <div class="d-flex align-center justify-center mb-2">
              <v-img
                max-height="40"
                max-width="40"
                src="@/assets/check-green.png"
              ></v-img>
            </div>
            <v-card-text class="text-center font-weight-bold">
              {{ this.showMessage }}
            </v-card-text>
            <v-card-text class="text-center">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                class="text-capitalize ml-2"
                small
                text
                color="black"
                @click="toLogin"
              >
                Login
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="showSnackbar" :color="snackbarColor">
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text small v-bind="attrs" @click="showSnackbar = false">
          X
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ForgotPassword",
  data() {
    return {
      valid: true,
      userType: localStorage.getItem("login__selectedUserType"),
      email: "",
      usernameRules: [
        (v) => !!v || "NIK harus diisi",
        (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail harus valid'
        // v => v.length >= 6 || 'Min 6 characters'
      ],
      showDialogSuccess: false,
      showMessage: ''
    };
  },
  methods: {
    ...mapActions(["forgotPass", "refreshToken"]),
    toLogin(){
      this.$router.push({name: 'login'});
    },
    forgotPassAction(){
      this.forgotPass(
        this.email
      )
      .then((response) => {
        if (response.data.status == 1) {
          this.showDialogSuccess = true;
          this.showMessage = response.data.message;
        }
      });
    },
    // handleForgotPass: function () {
    //   let username = this.email;
    //   let userType = this.userType;
    //     this.forgotPass({ username, userType })
    //     .then((response) => {
    //       this.$helpers.handleSuccess(response);

    //       let data = response.data;
    //       if (data.status == 1) this.$router.push({ name: "login" });
    //     })
    //     .catch((error) => {
    //       this.$helpers.handleError(error);
    //     });
    // },
    // handleUserType: function (val) {
    //   localStorage.setItem("login__selectedUserType", val);
    // },
  },
  computed: {
    validateEmail(){
      return String(this.email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    showSnackbar: {
      get: function () {
        return this.$store.getters.showSnackbar;
      },
      set: function () {
        this.$store.commit("hideSnackBar");
      },
    },
    snackbarMsg: {
      get: function () {
        return this.$store.getters.snackbarMsg;
      },
      set: function () {
        this.$store.commit("resetSnackBarMsg");
      },
    },
    snackbarColor: {
      get: function () {
        return this.$store.getters.snackbarColor;
      },
      set: function () {
        this.$store.commit("resetSnackBarColor");
      },
    },
  }
};
</script>

<style src="../Login/Login.scss" lang="scss"/>
